import { render, staticRenderFns } from "./campaignStatusesModel.vue?vue&type=template&id=0cd61dda&"
import script from "./campaignStatusesModel.vue?vue&type=script&lang=js&"
export * from "./campaignStatusesModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports